/**
 * ActionChoice Component (T049-T052)
 *
 * Displays two action buttons after 6 user messages:
 * 1. "Talk to Specialist Now" - Request immediate specialist assignment
 * 2. "Take Assessment First" - Start questionnaire flow with AI category suggestion
 *
 * Shown inline in chat interface when action_choice WebSocket event is received.
 */

import React from 'react'
import styles from './ActionChoice.module.css'

interface ActionChoiceProps {
  message: string
  onSelectSpecialist: () => void
  onSelectAssessment: () => void
  onDismiss?: () => void
}

export const ActionChoice: React.FC<ActionChoiceProps> = ({
  message,
  onSelectSpecialist,
  onSelectAssessment,
  onDismiss,
}) => {
  return (
    <div className={styles.actionChoiceContainer} role="alert" aria-live="polite">
      <div className={styles.messageText}>
        <p>{message}</p>
      </div>

      <div className={styles.buttonGroup}>
        <button
          type="button"
          className={`${styles.actionButton} ${styles.specialistButton}`}
          onClick={onSelectSpecialist}
          aria-label="Talk to a specialist now"
        >
          <span className={styles.buttonIcon}>👨‍⚕️</span>
          <span className={styles.buttonText}>Talk to Specialist Now</span>
        </button>

        <button
          type="button"
          className={`${styles.actionButton} ${styles.assessmentButton}`}
          onClick={onSelectAssessment}
          aria-label="Take assessment first"
        >
          <span className={styles.buttonIcon}>📋</span>
          <span className={styles.buttonText}>Take Assessment First</span>
        </button>
      </div>

      {onDismiss && (
        <button
          type="button"
          className={styles.dismissButton}
          onClick={onDismiss}
          aria-label="Dismiss action choice"
        >
          Maybe later
        </button>
      )}
    </div>
  )
}
